import React from 'react';

import { VenuesDailyDemandProvider } from './context/venuesDailyDemandContext';
import VenuesDailyDemandTable from './VenuesDailyDemandTable';

export default function VenuesDailyDemand({
    eventStartDate,
    eventEndDate,
    orgStartDate,
    orgEndDate,
    venueDailyDemandIndexUrl,
    venueDailyDemandUpsertUrl,
    venueSportsIndexUrl,
    venuesIndexUrl,
}) {
    return (
        <VenuesDailyDemandProvider
            venueDailyDemandIndexUrl={venueDailyDemandIndexUrl}
            venueDailyDemandUpsertUrl={venueDailyDemandUpsertUrl}
            venueSportsIndexUrl={venueSportsIndexUrl}
            venuesIndexUrl={venuesIndexUrl}
            eventStartDate={eventStartDate}
            eventEndDate={eventEndDate}
            orgStartDate={orgStartDate}
            orgEndDate={orgEndDate}
        >
            <VenuesDailyDemandTable />
        </VenuesDailyDemandProvider>
    );
}
